import compact from 'lodash/compact';
import Cookies from 'js-cookie';
export const getcurrentCountry = (result) => {
  if (result.length) {
    const findComponent = getCountryAddress(result);
    const addressComponent = findComponent && findComponent[0]?.address_components;

    // const formateAdd = compact(
    //   addressComponent.map((el) => {
    //     if (el.long_name !== 'Unnamed Road') {
    //       return el.long_name;
    //     }
    //   })
    // );
    return addressComponent && addressComponent[0]?.short_name;
  } else {
    return 'looking for location';
  }
};
export const geoCodeShortName = {
  SA: 'KSA',
  AE: 'UAE',
  KW: 'KWT',
  EG: 'EGY',
};
export const validateServicedCountry = (geoCodeCountry) => {
  return geoCodeShortName[geoCodeCountry] ? true : false;
};
export const getCountryURL = (switchTo, env) => {
  const mapEnv = {
    uae: {
      uat: 'kfcuaeuatpwa.americanarest.com',
      production: 'uae.kfc.me',
      qa: 'kfcuaeqapwa.americanarest.com',
      dev1: 'kfcuaedevpwa.americanarest.com',
    },
    ksa: {
      uat: 'kfcksauatpwa.americanarest.com',
      production: 'saudi.kfc.me',
      qa: 'kfcksaqapwa.americanarest.com',
      dev1: 'kfcksadevpwa.americanarest.com',
    },

    egy: {
      uat: 'kfcegyuatpwa.americanarest.com',
      production: 'egypt.kfc.me',
      qa: 'kfcegyqapwa.americanarest.com',
      dev1: 'kfcegydevpwa.americanarest.com',
    },
    kwt: {
      uat: 'kfckwtuatpwa.americanarest.com',
      production: 'kuwait.kfc.me',
      qa: 'kfckwtqapwa.americanarest.com',
      dev1: 'kfckwtdevpwa.americanarest.com',
    },
  };
  return mapEnv[switchTo?.toLowerCase()][env];
};

export const getDefaultCountryValues = () => {
  const hostMap = {
    kfc: {
      uae: [
        'localhost:3000',
        'uae.kfc.me',
        'kfcuaeuatpwa.americanarest.com',
        'kfcuaeua.americanarest.com',
        'kfcuaeqapwa.americanarest.com',
        'kfcuaeqa2pwa.americanarest.com',
        'kfcuaedevpwa.americanarest.com',
      ],
      ksa: [
        'saudi.kfc.me',
        'kfcksauatpwa.americanarest.com',
        'www.saudi.kfc.me',
        'kfcksauat.americanarest.com',
        'kfcksaqapwa.americanarest.com',
        'kfcksaqa2pwa.americanarest.com',
        'kfcksadevpwa.americanarest.com',
      ],
      egy: [
        // 'localhost:3000',
        'egypt.kfc.me',
        'kfcegyuatpwa.americanarest.com',
        'kfcegyuat.americanarest.com',
        'kfcegyqapwa.americanarest.com',
        'kfcegyqa2pwa.americanarest.com',
        'kfcegydevpwa.americanarest.com',
      ],
      kwt: [
        'kfckwtqapwa.americanarest.com',
        'kuwait.kfc.me',
        'www.kuwait.kfc.me',
        'kfckwtuatpwa.americanarest.com',
        'kfckwtqa2pwa.americanarest.com',
        'kfckwtdevpwa.americanarest.com',
      ],
    },
  };

  let brand = 'kfc';
  let defaultCountry = 'uae';
  let defaultLang = 'En';
  if (hostMap.kfc.ksa.includes(window.location.host)) {
    defaultCountry = 'ksa';
    defaultLang = 'Ar';
  }
  if (hostMap.kfc.uae.includes(window.location.host)) {
    defaultCountry = 'uae';
    defaultLang = 'En';
  }

  if (hostMap.kfc.egy.includes(window.location.host)) {
    defaultCountry = 'egy';
    defaultLang = 'En';
  }

  if (hostMap.kfc.kwt.includes(window.location.host)) {
    defaultCountry = 'kwt';
    defaultLang = 'En';
  }
  return {
    brand: brand,
    defaultCountry: defaultCountry,
    defaultLang: defaultLang,
  };
};
export const getFormatedResult = (result) => {
  if (result.length) {
    const findComponent = getAddressComponentFirst(result);
    const addressComponent = getAddressComponent(findComponent[0]?.address_components);
    const formateAdd = compact(
      addressComponent?.map((el) => {
        if (el.long_name !== 'Unnamed Road') {
          return el.long_name;
        }
      })
    );

    return formateAdd.join(' - ');
  } else {
    return 'looking for location';
  }
};
const getCountryAddress = (components) => {
  let formate = [];
  components.forEach((value, index) => {
    if (value?.types?.length && value.types.includes('country')) {
      formate.push(value);
    }
  });
  return formate;
};
const getAddressComponent = (components) => {
  let formate = [];
  components &&
    components.forEach((value, index) => {
      if (value?.types?.length && isCorrectType(value.types)) {
        formate.push(value);
      }
    });
  return formate;
};

const getAddressComponentFirst = (components) => {
  let formate = [];
  components &&
    components.forEach((value, index) => {
      if (value?.types?.length && firstRoutType(value.types)) {
        formate.push(value);
      }
    });
  return formate;
};
const isCorrectType = (type) => {
  const countryName = Cookies.get('country');
  if (countryName === 'EGY') {
    return type.includes('sublocality') ||
      type.includes('locality') ||
      type.includes('street_address') ||
      type.includes('neighborhood') ||
      type.includes('route') ||
      type.includes('administrative_area_level_2') ||
      type.includes('administrative_area_level_1') ||
      type.includes('administrative_area_level_3') ||
      type.includes('administrative_area_level_4')
      ? true
      : false;
  }
  return type.includes('sublocality') ||
    type.includes('locality') ||
    type.includes('route') ||
    type.includes('street_address') ||
    type.includes('premise') ||
    type.includes('neighborhood')
    ? true
    : false;
};

const firstRoutType = (type) => {
  const countryName = Cookies.get('country');

  if (countryName === 'EGY') {
    return type.includes('sublocality') ||
      type.includes('locality') ||
      type.includes('street_address') ||
      type.includes('neighborhood') ||
      type.includes('route')
      ? true
      : false;
  }
  return type.includes('sublocality') ||
    type.includes('locality') ||
    type.includes('route') ||
    type.includes('street_address') ||
    type.includes('premise') ||
    type.includes('neighborhood')
    ? true
    : false;
};

export const searchStores = (storeList = [], storeEntities, modeIndex) => {
  const modeMapping = {
    CARHOP: 'carHop',
    DELIVERY: 'del',
    STORE: 'tak',
    DINEIN: 'din',
    DRIVETHRU: 'driveThru',
  };
  let list = [];
  storeList.map((val) => {
    const storeDetail = storeEntities[val];
    if (storeDetail && storeDetail.services[modeMapping[modeIndex.type]]) {
      list.push(val);
    }
  });
  // Object.entries(storeEntities).map(([cityKey, cityVal]) => {

  // }

  return list;
};

export const searchStoresKeyword = (
  storeList = [],
  storeEntities,
  searchKeyword,
  locale = 'en'
) => {
  let list = [];
  const nameStore = `name_${locale.toLowerCase()}`;
  storeList.map((val) => {
    const storeDetail = storeEntities[val];
    if (
      storeDetail[nameStore] &&
      storeDetail[nameStore].toLowerCase().includes(
        searchKeyword
          .replace(/\s{2,}/g, ' ')
          .trim()
          .toLowerCase()
      )
    ) {
      list.push(val);
    }
  });
  // Object.entries(storeEntities).map(([cityKey, cityVal]) => {

  // }

  return list;
};
export const allowedCountry = (country) => {
  const allowCountry = ['KSA', 'UAE', 'EGY', 'KWT'];
  if (allowCountry.includes(country.toUpperCase())) {
    return true;
  } else {
    return false;
  }
};
export const capitalizeFirstLetter = ([first, ...rest]) =>
  first.toUpperCase() + rest.join('').toLowerCase();

export const getOrderModeLink = ({ path, modeType, isDesktop, locale }) => {
  if (isDesktop) {
    return `${path}?modal=${modeType.toLowerCase()}`;
  } else {
    return `/${locale.toLowerCase()}/${modeType.toLowerCase()}`;
  }
};

export const localizePath = (path, locale) => {
  const isLocalized = path.match(/^\/?en\//) || path.match(/^\/?ar\//);
  let localizedPath = path;

  if (!isLocalized) {
    const lang = locale.toLowerCase().split('-')[0];
    const hasLeadingSlash = path.match(/^\//);
    const localeFragment = `/${lang}${hasLeadingSlash ? '' : '/'}`;

    localizedPath = `${localeFragment}${path}`;
  }

  return localizedPath;
};

export const getDefaultDependent = (bundleProductOptions = []) => {
  let groupDepend = [];
  bundleProductOptions.forEach((val) => {
    const value = val.options?.forEach((inner) => {
      if (inner?.dependentSteps?.length > 0 && inner.default === 1 && inner.selected === 1) {
        inner.dependentSteps.forEach((steps) => {
          groupDepend.push(steps);
        });
      }
    });
  });
  return groupDepend;
};

const ifCustomized = (
  { bundleProductOptions, addOn, custom, customized },
  menuItem,
  separator = ', '
) => {
  // const customizations = compact(custom)
  //   .map((item) => item.name)
  //   .join(separator);
  // const addOns = compact(addOn)
  //   .map((item) => item.name)
  //   .join(separator);

  // return customizations + addOns;
  let allVal = [];
  if (bundleProductOptions && bundleProductOptions.length) {
    bundleProductOptions.forEach((val, idx) => {
      if (
        (val.isAddon ||
          val.type === 'radio' ||
          val.type === 'checkbox' ||
          val.type === 'stepper') &&
        val.productLinks.length
      ) {
        val.productLinks.forEach((inner, innerIdx) => {
          if (inner.selected) {
            if (menuItem) {
              const itemDetail = {
                ...menuItem.bundleProductOptions[idx].productLinks[innerIdx],
                qty: inner.selectionQty,
              };
              allVal.push(itemDetail);
            } else {
              const vals = {
                ...inner,
                qty: inner.selectionQty,
              };
              allVal.push(vals);
            }
          }
        });
      }
    });
    return compact(allVal)
      .map((item) => {
        // const qty = item.selectionQty > 1 ? item.selectionQty : '';
        return (item.qty > 1 ? item.qty : '') + ' ' + item.name;
      })
      .join(separator);
  }
};

const getDescription = (customItem, menuItem, separator = ', ') => {
  let allVal = [];
  let dependent = [];
  const { steps } = customItem;
  if (steps && steps.length) {
    steps.forEach((val, idx) => {
      if (idx === 0 && customItem.variants.length) {
        const vals = {
          name: menuItem ? menuItem.title : customItem.title,
          qty: 0,
        };
        allVal.push(vals);
      }
      if (
        (val.isAddon ||
          val.type === 'radio' ||
          val.type === 'checkbox' ||
          val.type === 'stepper') &&
        val?.options?.length &&
        val.isDependent !== 1
      ) {
        val.options.forEach((inner, innerIdx) => {
          // FOR DEFAULT INNER SELECTION
          if (inner.selectionQty && inner?.subOptions?.length > 0) {
            // eslint-disable-next-line no-unused-expressions
            let itemVal = {};
            steps[idx].options[innerIdx].subOptions.forEach((subOpt) => {
              if (subOpt.default && subOpt.selected) {
                itemVal = {
                  ...inner,
                  qty: val.isTopping ? 0 : inner.selectionQty,
                };
                return;
              } else {
                itemVal = {
                  ...inner,
                  qty: val.isTopping ? 0 : inner.selectionQty,
                };
                return;
              }
            });
            allVal.push(itemVal);
          }

          if (inner.selected) {
            if (inner?.dependentSteps?.length > 0) {
              // eslint-disable-next-line no-unused-expressions
              steps[idx]?.options[innerIdx]?.dependentSteps.map((val) => {
                dependent.push(val);
              });
            }
            if (menuItem) {
              const itemDetail = {
                ...menuItem.steps[idx].options[innerIdx],
                qty: val.type === 'stepper' ? inner.selectionQty : 0,
              };
              allVal.push(itemDetail);
            } else {
              const vals = {
                ...inner,
                qty: val.type === 'stepper' ? inner.selectionQty : 0,
              };
              allVal.push(vals);
            }
          }
        });
      }
    });
    steps.forEach((val, idx) => {
      if (dependent.includes(val.position)) {
        val.options.forEach((inner, innerIdx) => {
          if (inner.selected) {
            const vals = {
              ...inner,
              qty: inner.selectionQty,
            };
            allVal.push(vals);
          }
        });
      }
    });

    return compact(allVal)
      .map((item) => {
        return (item.qty !== 0 ? `${item.qty} - ` : '') + item.title.trim();
      })
      .join(separator);
  }
};
export const getTitleOfItems = (items) => {
  let title = '';
  items.forEach((itm, i) => {
    title = title + itm.name;
    if (items.length - 1 !== i) {
      title = title + ', ';
    }
  });
  if (title.length > 50) {
    title = title.substring(0, 50) + '..';
  }
  return title;
};
export const generateCustomization = (product, menuItem, separator) => {
  try {
    if (product?.items?.length >= 1) {
      const index = product.items?.findIndex((obj) => obj.sku === product.selectedItem);
      const item = index !== -1 ? (product.items ? product.items[index] : null) : null;
      const innerItem = index !== -1 ? (menuItem?.items ? menuItem?.items[index] : null) : null;

      return item ? getDescription(item, innerItem, separator) : getDescription(product, separator);
    } else {
      return getDescription(product, separator);
    }
  } catch (err) {
    console.log(err);
  }
};
export const generateCustomizationOnly = (product, separator) => {
  const index = product.items?.findIndex((obj) => obj.sku === product.selectedItem);

  const item = index ? product.items[index] : null;
  return item ? getDescription(item, separator) : getDescription(product, separator);
};
export const getSortedWidget = (widgets) => {
  let bannerMedium = [];
  widgets.forEach((widget) => {
    if (
      widget.widgetType === 'BANNER_MEDIUM' ||
      widget.widgetType === 'BANNER_SMALL' ||
      widget.widgetType === 'BANNER_VIDEO'
    ) {
      bannerMedium.push(widget);
    }
  });
  if (bannerMedium.length % 2 != 0) {
    bannerMedium.push({
      content: '',
      ctaAction: [],
      id: 407,
      language: 'En',
      media: [],
      productButtonTitle: '',
      products: [],
      sequence: 10,
      status: 1,
      title: '',
      unicode: '',
      widgetType: 'BANNER_EXTRA',
    });
  }
  return bannerMedium;
};
export const decimalChecker = (input) => {
  const countryName = Cookies.get('country');
  if (countryName === 'KWT') {
    return input % 1 === 0 ? input : input?.toFixed(3);
  }
  return input % 1 === 0 ? input : input?.toFixed(2);
};

export const orderStatusHelper = (status, orderStatusArray = []) => {
  return orderStatusArray?.find((obj) => obj.name === status)?.value || '';
};

export const numberWithSpaces = (value, pattern) => {
  var i = 0;
  if (value.length) {
    var phone = value.toString();
    return pattern.replace(/#/g, function (x) {
      return phone[i++] || '';
    });
  }
};

// MAKE CUSTOMISE ITEM PAYLOAD
export const getCustmisedItemObj = (params) => {
  const {
    selectedProduct = {},
    selectedItems = [],
    selectedVariant = [],
    catId = '',
    variantSizeObj = {},
    checkDependent = [],
    productID,
    UUID = '',
    customiseItemsArr = [],
    setCustomisingItemList,
    dispatch,
    isExist = -1,
  } = params;
  let itemArr = customiseItemsArr.slice();
  const parentId =
    selectedProduct?.typeId !== 'simple' ? { parentId: selectedProduct?.parent_id } : '';

  let itmObj = selectedItems.find((o) => o.id === +productID);
  let custmizePayloadObj = {};

  // ADD OR UPDATE ITEM QUANTITY ONLY
  if (isExist > -1) {
    const currQty = selectedItems[isExist].qty;
    const updateItem = {
      ...itemArr[isExist],
      qty: currQty,
      price: currQty * selectedItems[isExist].calculatedPrice,
    };
    itemArr.splice(isExist, 1);
    itemArr.unshift(updateItem);
  }

  if (selectedProduct && Object.keys(selectedProduct).length) {
    // ADD ITEMS IF IT EXIST
    custmizePayloadObj = {
      id: selectedProduct.id,
      ...parentId,
      catId: +catId,
      name: selectedProduct?.name,
      typeId: selectedProduct?.typeId,
      price: selectedProduct.tempPrice || selectedProduct.originalPrice,
      description: selectedProduct?.description || selectedProduct?.longDesc,
      qty: itmObj.qty,
      UUID,
      parentId,
      calculatedPrice: selectedItems[0].tempPrice,
      tempPrice: selectedItems[0].tempPrice,
      selectedItem: selectedItems[0].sku,
    };
  }

  let prdItem = {};
  //SELECTED PRODUCT GO THROUGH FOR THE PAYLOAD
  if (selectedItems && selectedItems[0].steps && selectedItems[0].steps.length > 0) {
    selectedItems[0].steps.forEach((item) => {
      return (
        item?.options &&
        item?.options.length > 0 &&
        item?.options.forEach((opt, idx) => {
          // IF ANY DEPENDED CASE THEN CONTINUE THE FLOW
          if (item.isDependent && !checkDependent.includes(item.id)) {
            return true;
          } else {
            if ((opt.selected && opt.selectionQty) || opt.selected || opt.selectionQty) {
              // DEFAULT CASE
              if (opt.selected && opt.default) {
                return false;
              }
              //ITEM OBJECT TO BE ADD TO PAYLOAD
              let valItem = { [opt.id]: { qty: opt.selectionQty ? opt.selectionQty : 1 } };
              //DEFAULT INGRIEDIENT CASE
              if (opt.selectionQty && opt.subOptions.length > 0) {
                if (opt.subOptions[idx].default && opt.subOptions[idx].selected) {
                  return (prdItem[item.id] = { ...valItem });
                } else {
                  return (prdItem[item.id] = { ...valItem });
                }
              }
              // IF ITEM HAS SAME ADD PUSH UNDER THAT ID
              if (prdItem[item.id]) {
                return (prdItem[item.id][opt.id] = {
                  qty: opt.selectionQty ? opt.selectionQty : 1,
                });
              } else {
                return (prdItem[item.id] = { ...valItem });
              }
            }
          }
        })
      );
    });
    // IF PRODUCT HAS ANY CUSTOMIZATION THEN PUSH THE ITEM
    if (Object.keys(prdItem).length) {
      const key = selectedProduct?.typeId === 'simple' ? 'items' : 'bundle';
      custmizePayloadObj = {
        ...custmizePayloadObj,
        [key]: { ...prdItem },
      };
      // ADD VARIANTS IF IT EXIST
      if (selectedVariant.length) {
        custmizePayloadObj = {
          ...custmizePayloadObj,
          variants: { [variantSizeObj.optMainId]: variantSizeObj.selectedSizeId },
        };
      }
    }
  }
  // CHECK FOR CUSTOMIZATION CASE IF ANY CUSTOMIZATION DONE
  if (Object.keys(custmizePayloadObj).length && Object.keys(prdItem).length) {
    itemArr = [...itemArr, custmizePayloadObj];
    dispatch(setCustomisingItemList(custmizePayloadObj));
  } else {
    // DEFAULT PUSH IF NOT ANY PRODUCT CUSTOMIZED
    if (!isEmptyObject(custmizePayloadObj)) {
      itemArr = [...itemArr, custmizePayloadObj];
      dispatch(setCustomisingItemList(custmizePayloadObj));
    }
  }
  return itemArr;
};

// CHECK FOR EMPTY OBJECT
function isEmptyObject(obj) {
  return JSON.stringify(obj) === '{}';
}

export const getSelectedItem = (customization, product) => {
  let variantKeys = Object.values(customization?.variants || {});
  if (!variantKeys?.length && product?.variants) {
    for (let variant of product?.variants || []) {
      for (let option of variant?.options || []) {
        if (option?.isSelected) variantKeys.push(option?.id);
      }
    }
  }

  return product?.items?.find((item) => {
    let isSameVariant = true;
    for (let i = 0; i < variantKeys?.length || 0; i++) {
      if (item[`sel${i + 1}Value`] !== variantKeys[i]) {
        isSameVariant = false;
        break;
      }
    }
    return isSameVariant;
  });
};
